import { useIsAdminOrModerator } from "@circle-react/contexts/punditUserContext";

import { t } from "@/i18n-js/instance";

import { CircleAIBuildNavSection } from "./CircleAIBuildNavSection";
import type { BuildNavItem } from "./types";

interface CircleAIAgentsSectionProps {
  items: BuildNavItem[];
  onToggleGroup: (id: string) => void;
  openGroupId: string | undefined;
}

export const CircleAIAgentsSection = ({
  items,
  onToggleGroup,
  openGroupId,
}: CircleAIAgentsSectionProps) => {
  const canUseBuildNav = useIsAdminOrModerator();

  if (!canUseBuildNav || items.length === 0) return null;

  return (
    <CircleAIBuildNavSection
      title={t("circle_ai_dock.sections.agents")}
      items={items}
      openGroupId={openGroupId}
      onToggleGroup={onToggleGroup}
    />
  );
};
